module.exports = __webpack_public_path__ + "img/2021年5月28日 冰眸新版上线测试中462.d492a69a.jpg";